/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../../components/Modal/ReactBootstrapModal';

import DrawPlayersListV2 from './DrawPlayersListV2';
import DrawRoundPlayersListV2 from './DrawRoundPlayersListV2';
import SingleSelectPopup from '../../components/PopUps/SingleSelectPopup';
import ConfirmActionPopup from '../../components/PopUps/ConfirmActionPopup';
import Img from '../../components/Img';

import * as drawEditActions from '../../actions/draw-edit-actions';
import { arraysEqual } from '../../utils';
import { eventFormatTypeIds, drawPlacementStatusTypeIds } from '../../utils/eventConstants';

import styles from './drawEdit.scss';
import { isPickleBallSportTypeEvent } from '../../utils/events';
import { ratingTypes, sortParamTypes } from '../../utils/constants';
import { showErrorPopup, showErrorToast } from '../../actions/notification-actions';
import { useStatsig } from '../../components/hooks/useStatsig';
import { hasRetiredTag } from '../../utils/types';

const DrawsPlayerListWrapperV2 = (props) => {
    const { players, teams, membersInDraw, membersPlaced, membersInWaitlist, membersInTeams, teamsInDraw, teamsPlaced, teamsInWaitlist, membersHaveResults, teamsHaveResults, available = [], isReadOnly, utrType, utrTypeId, unsavedChanges, isGroupDraw, autofill, setAutofill, autofillRatingWarning, setAutofillRatingWarning, showAutofillModal, move, setMove, sportTypeId, isPTTEvent } = props;
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const { selected, selectedNotInDraw, selectedTeams, selectedTeamsNotInDraw, isSaving, playersDict, playersDictByMemberId, teamsDict, preventSelectMove, currentDraw, parentDraw, draws } = useSelector(({ drawEdit }) => {
        const { selected, selectedNotInDraw, selectedTeams, selectedTeamsNotInDraw, isSaving, players, teams, preventSelectMove, currentDraw, parentDraw, draws } = drawEdit;
        return {
            selected,
            selectedNotInDraw,
            selectedTeams,
            selectedTeamsNotInDraw,
            isSaving,
            playersDict: players.playersDict,
            playersDictByMemberId: players.playersDictByMemberId,
            teamsDict: teams.teamsDict,
            preventSelectMove,
            currentDraw,
            parentDraw,
            draws,
        };
    });
    const getSeedMembersData = (draw) => {
        return draw.data.members.map(({ memberId, seedNumber }) => ({
            memberId,
            seedNumber,
        }));
    };
    const getSeedTeamsData = (draw) => {
        return draw.data.teams.map(({ teamId, seedNumber }) => ({
            teamId,
            seedNumber,
        }));
    };
    const dispatch = useDispatch();
    const { checkGate, featureGates } = useStatsig();
    const newSeedingSettingsEnabled = checkGate(featureGates.NEW_SEEDING_SETTINGS);
    const { drawTagTypes } = coreUI.types.tms.draw;
    const tagTypes = isPTTEvent ? Object.values(drawTagTypes) : Object.values(drawTagTypes.slice(0, 4));

    const [remove, setRemove] = useState({
        showModal: false,
    });
    const [split, setSplit] = useState({ showModal: false });
    const [tagPlayer, setTagPlayer] = useState({ showModal: false });

    const isPickleBallEvent = isPickleBallSportTypeEvent(sportTypeId);
    const [playersFilter, setPlayersFilter] = useState({
        value: isPickleBallEvent ? 'pkbr_desc' : 'utr_desc',
        label: `${isPickleBallEvent ? ratingTypes.pickleball : ratingTypes.tennis} (high to low)`,
    });
    const [selectedSection, setSelectedSection] = useState({});
    const [playerListFilter, setPlayerListFilter] = useState(''); // filter query

    const [seedTypeSetting, setSeedTypeSetting] = useState(currentDraw?.data?.drawSeedingSettings?.seedingTypeId || 1);
    const [seedPercentageSetting, setSeedPercentageSetting] = useState(currentDraw?.data?.drawSeedingSettings?.seedingPercentage || undefined);
    const [hideSeedNumbers, setHideSeedNumbers] = useState(currentDraw?.data?.drawSeedingSettings?.hideSeedNumbers);
    const [displaySeedingOrder, setDisplaySeedingOrder] = useState(newSeedingSettingsEnabled && currentDraw?.data?.drawSeedingSettings?.seedingTypeId === 2);
    const [seedingManualOrderMember, setSeedingManualOrderMember] = useState(getSeedMembersData(currentDraw) || []);
    const [seedingManualOrderTeam, setSeedingManualOrderTeam] = useState(getSeedTeamsData(currentDraw) || []);
    const [showSeedVisibilityUpdateConfirmationModal, setShowSeedVisibilityUpdateConfirmationModal] = useState(false);
    const [showTagConfirmPopup, setShowTagConfirmPopup] = useState(false);
    const [tagId, setTagId] = useState(null);
    let notPlaced;
    let placed;
    let waitlist;
    let notInDraw;
    let notInDrawTeams;

    if (currentDraw.data.formatTypeId === eventFormatTypeIds.SINGLES) {
        notPlaced = players.filter(player => membersInDraw?.includes(player.memberId) && !membersPlaced.includes(player.memberId) && !membersInWaitlist?.includes(player.memberId));
        placed = (players.filter(player => membersInDraw?.includes(player.memberId) && membersPlaced.includes(player.memberId)));
        waitlist = players.filter(player => membersInWaitlist?.includes(player.memberId));
        notInDraw = players.filter(player => !membersInDraw?.includes(player.memberId));
    } else {
        notPlaced = teams.filter(team => teamsInDraw?.includes(team.id) && !teamsPlaced.includes(team.id) && !teamsInWaitlist?.includes(team.id));
        placed = teams.filter(team => teamsInDraw?.includes(team.id) && teamsPlaced.includes(team.id));
        waitlist = teams.filter(team => teamsInWaitlist?.includes(team.id));
        notInDraw = players.filter(player => !(membersInTeams?.includes(player.memberId) || membersInDraw?.includes(player.memberId)));
        notInDrawTeams = teams.filter(team => !teamsInDraw?.includes(team.id));
    }

    useEffect(() => {
        if (currentDraw?.data?.id) {
            setSeedTypeSetting(currentDraw?.data?.drawSeedingSettings?.seedingTypeId);
            setSeedPercentageSetting(currentDraw?.data?.drawSeedingSettings?.seedingPercentage);
            setHideSeedNumbers(currentDraw?.data?.drawSeedingSettings?.hideSeedNumbers);
            setSeedingManualOrderMember(getSeedMembersData(currentDraw) || []);
            setSeedingManualOrderTeam(getSeedTeamsData(currentDraw) || []);
            setDisplaySeedingOrder(newSeedingSettingsEnabled && currentDraw?.data?.drawSeedingSettings?.seedingTypeId === 2);
        }
    }, [currentDraw?.data?.id]);

    // PLAYER ACTIONS

    const addToDraw = () => {
        dispatch(drawEditActions.setResetTimer(true));
        dispatch(drawEditActions.addToDraw());
        dispatch(drawEditActions.setSelectedNotInDraw([]));
        dispatch(drawEditActions.setSelectedTeamsNotInDraw([]));
    };

    const addToBackdraw = ({ teamId, memberId }) => {
        dispatch(drawEditActions.setResetTimer(true));
        const backDraw = draws.drawsDict?.[currentDraw.data.id]?.childDraws[0];
        if (memberId) {
            dispatch(drawEditActions.setSelected([memberId]));
        }
        if (teamId) {
            dispatch(drawEditActions.setSelectedTeams([teamId]));
        }
        dispatch(drawEditActions.movePlayers({ toDrawId: backDraw.id, isCopy: true, isChildDraw: true }));
    };

    const removePlayers = () => {
        dispatch(drawEditActions.setResetTimer(true));
        dispatch(drawEditActions.removeFromDraw({ selected, selectedTeams }));
        dispatch(drawEditActions.setSelected([]));
        dispatch(drawEditActions.setSelectedTeams([]));
        setRemove({ showModal: false });
    };

    const createTeam = () => {
        dispatch(drawEditActions.setResetTimer(true));
        dispatch(drawEditActions.createTeam());
        dispatch(drawEditActions.setSelected([]));
    };

    const splitTeams = () => {
        dispatch(drawEditActions.setResetTimer(true));
        dispatch(drawEditActions.splitTeams({ selectedTeams }));
        dispatch(drawEditActions.removeFromDraw({ selected: [], selectedTeams }));
        dispatch(drawEditActions.setSelectedTeams([]));
        setSplit({
            showModal: false,
        });
    };

    useEffect(() => {
        if (!selected.length && !selectedTeams.length) {
            setSelectedSection({
                all: false,
                [drawPlacementStatusTypeIds.NOT_PLACED]: false,
                [drawPlacementStatusTypeIds.PLACED]: false,
                [drawPlacementStatusTypeIds.WAITLIST]: false,
            });
        }
    }, [selected, selectedTeams]);

    const togglePlayerSelect = useCallback(id => {
        dispatch(drawEditActions.setResetTimer(true));
        const idx = selected.indexOf(id);
        let selectedPlayers;
        if (idx > -1) {
            selectedPlayers = [...selected.slice(0, idx), ...selected.slice(idx + 1)];
        } else {
            selectedPlayers = [...selected, id];
        }
        const prevSelectMove = selectedPlayers.some(memberId => {
            return membersHaveResults.includes(memberId);
        });
        dispatch(drawEditActions.setSelected(selectedPlayers));
        dispatch(drawEditActions.setPreventSelectMove(prevSelectMove));
        dispatch(drawEditActions.setSelectedNotInDraw([]));
        dispatch(drawEditActions.setSelectedTeamsNotInDraw([]));
    }, [selected]);

    const toggleNDPlayerSelect = useCallback(id => {
        dispatch(drawEditActions.setResetTimer(true));
        const idx = selectedNotInDraw.indexOf(id);
        if (idx > -1) {
            dispatch(drawEditActions.setSelectedNotInDraw([...selectedNotInDraw.slice(0, idx), ...selectedNotInDraw.slice(idx + 1)]));
        } else {
            dispatch(drawEditActions.setSelectedNotInDraw([...selectedNotInDraw, id]));
        }
        dispatch(drawEditActions.setSelected([]));
        dispatch(drawEditActions.setSelectedTeams([]));
    }, [selectedNotInDraw]);

    const toggleTeamSelect = useCallback(id => {
        dispatch(drawEditActions.setResetTimer(true));
        const idx = selectedTeams.indexOf(id);
        let teamSelectArr;
        if (idx > -1) {
            teamSelectArr = [...selectedTeams.slice(0, idx), ...selectedTeams.slice(idx + 1)];
        } else {
            teamSelectArr = [...selectedTeams, id];
        }
        const prevSelectMove = teamSelectArr.some(teamId => {
            if (teamsHaveResults.includes(teamId)) {
                return true;
            }
            return false;
        });
        dispatch(drawEditActions.setSelectedTeams(teamSelectArr));
        dispatch(drawEditActions.setPreventSelectMove(prevSelectMove));
        dispatch(drawEditActions.setSelectedNotInDraw([]));
        dispatch(drawEditActions.setSelectedTeamsNotInDraw([]));
    }, [selectedTeams]);

    const toggleNDTeamSelect = useCallback(id => {
        dispatch(drawEditActions.setResetTimer(true));
        const idx = selectedTeamsNotInDraw.indexOf(id);
        if (idx > -1) {
            dispatch(drawEditActions.setSelectedTeamsNotInDraw([...selectedTeamsNotInDraw.slice(0, idx), ...selectedTeamsNotInDraw.slice(idx + 1)]));
        } else {
            dispatch(drawEditActions.setSelectedTeamsNotInDraw([...selectedTeamsNotInDraw, id]));
        }
        dispatch(drawEditActions.setSelected([]));
        dispatch(drawEditActions.setSelectedTeams([]));
    }, [selectedTeamsNotInDraw]);

    const handleSelectAll = useCallback(() => {
        dispatch(drawEditActions.setResetTimer(true));
        let prevSelectMove = false;
        membersInDraw.forEach(memberId => {
            if (membersHaveResults.includes(memberId)) {
                prevSelectMove = true;
            }
        });
        teamsInDraw.forEach(teamId => {
            if (teamsHaveResults.includes(teamId)) {
                prevSelectMove = true;
            }
        });
        if (arraysEqual(selected, membersInDraw) && arraysEqual(selectedTeams, teamsInDraw)) {
            dispatch(drawEditActions.setSelected([]));
            dispatch(drawEditActions.setSelectedTeams([]));
            setSelectedSection({
                all: false,
                [drawPlacementStatusTypeIds.NOT_PLACED]: false,
                [drawPlacementStatusTypeIds.PLACED]: false,
                [drawPlacementStatusTypeIds.WAITLIST]: false,
            });
        } else {
            dispatch(drawEditActions.setSelected(membersInDraw));
            dispatch(drawEditActions.setSelectedTeams(teamsInDraw));
            setSelectedSection({
                all: true,
                [drawPlacementStatusTypeIds.NOT_PLACED]: true,
                [drawPlacementStatusTypeIds.PLACED]: true,
                [drawPlacementStatusTypeIds.WAITLIST]: true,
            });
        }
        dispatch(drawEditActions.setPreventSelectMove(prevSelectMove));
    }, [selected, selectedTeams, membersInDraw, teamsInDraw, membersHaveResults, teamsHaveResults]);

    const toggleSectionSelect = useCallback((e, statusId) => {
        dispatch(drawEditActions.setResetTimer(true));
        e.stopPropagation();
        let selectedSectionPlayers = [];
        let prevSelectMove = false;

        const isSingles = currentDraw.data.formatTypeId === eventFormatTypeIds.SINGLES;
        let setSelected = [...selected];
        let setSelectedTeams = [...selectedTeams];

        if (statusId === drawPlacementStatusTypeIds.PLACED) {
            selectedSectionPlayers = placed.map(p => p.memberId || p.id);
        }
        if (statusId === drawPlacementStatusTypeIds.NOT_PLACED) {
            selectedSectionPlayers = notPlaced.map(p => p.memberId || p.id);
        }
        if (statusId === drawPlacementStatusTypeIds.WAITLIST) {
            selectedSectionPlayers = waitlist.map(p => p.memberId || p.id);
        }

        if (isSingles) {
            selectedSectionPlayers.forEach(memberId => {
                const idx = setSelected.indexOf(memberId);
                if (selectedSection[statusId]) {
                    setSelected = [...setSelected.slice(0, idx), ...setSelected.slice(idx + 1)];
                } else if (idx === -1) {
                    setSelected = [...setSelected, memberId];
                }
            });
        } else {
            selectedSectionPlayers.forEach(teamId => {
                const idx = setSelectedTeams.indexOf(teamId);
                if (selectedSection[statusId]) {
                    setSelectedTeams = [...setSelectedTeams.slice(0, idx), ...setSelectedTeams.slice(idx + 1)];
                } else if (idx === -1) {
                    setSelectedTeams = [...setSelectedTeams, teamId];
                }
            });
        }
        setSelected.some(memberId => {
            if (membersHaveResults.includes(memberId)) {
                prevSelectMove = true;
            }
            return false;
        });
        setSelectedTeams.some(teamId => {
            if (teamsHaveResults.includes(teamId)) {
                prevSelectMove = true;
            }
            return false;
        });
        if (setSelected) {
            dispatch(drawEditActions.setSelected(setSelected));
        }
        if (setSelectedTeams) {
            dispatch(drawEditActions.setSelectedTeams(setSelectedTeams));
        }
        setSelectedSection({
            ...selectedSection,
            [statusId]: !selectedSection[statusId],
        });
        dispatch(drawEditActions.setPreventSelectMove(prevSelectMove));
    }, [selected, selectedTeams, placed, notPlaced, waitlist]);

    const setPlayerStatus = ({ value, teamId, memberId }) => {
        dispatch(drawEditActions.setResetTimer(true));
        dispatch(drawEditActions.setPlayerStatus({ value, teamId, memberId }));
    };

    const handlePlayerPopoverClick = ({ value, playerId, teamId, memberId }) => {
        dispatch(drawEditActions.setResetTimer(true));
        switch (value) {
            case 'waitlist':
            case 'not_placed':
                setPlayerStatus({ value, teamId, memberId });
                break;
            case 'backdraw':
                addToBackdraw({ teamId, memberId });
                break;
            case 'addToDraw':
                if (memberId) {
                    dispatch(drawEditActions.setSelectedNotInDraw([memberId]));
                }
                if (teamId) {
                    dispatch(drawEditActions.setSelectedTeamsNotInDraw([teamId]));
                }
                addToDraw();
                break;
            case 'profile':
                if (playerId) {
                    window.open(`/profiles/${playerId}`, '_blank');
                }
                break;
            case 'tag':
                setTagPlayer({
                    showModal: true,
                    memberId,
                    teamId,
                });
                break;
            default:
                break;
        }
    };

    const handleSortPlayersClick = (option) => {
        dispatch(drawEditActions.setResetTimer(true));
        const isSingles = currentDraw.data.formatTypeId === eventFormatTypeIds.SINGLES;
        let sortParam;
        let sortType;
        let seedsArray;
        switch (option.value) {
            case 'utr_desc':
                sortParam = isSingles ? sortParamTypes.SINGLESUTR : sortParamTypes.DOUBLESUTR;
                sortType = 'desc';
                break;

            case 'utr_asc':
                sortParam = isSingles ? sortParamTypes.SINGLESUTR : sortParamTypes.DOUBLESUTR;
                sortType = 'asc';
                break;

            case 'pkbr_desc':
                sortParam = isSingles ? sortParamTypes.SINGLESPKB : sortParamTypes.DOUBLESPKB;
                sortType = 'desc';
                break;

            case 'pkbr_asc':
                sortParam = isSingles ? sortParamTypes.SINGLESPKB : sortParamTypes.DOUBLESPKB;
                sortType = 'asc';
                break;

            case 'first_desc':
                sortParam = sortParamTypes.FIRST_NAME;
                sortType = 'desc';
                break;

            case 'first_asc':
                sortParam = sortParamTypes.FIRST_NAME;
                sortType = 'asc';
                break;

            case 'last_desc':
                sortParam = sortParamTypes.LAST_NAME;
                sortType = 'desc';
                break;

            case 'last_asc':
                sortParam = sortParamTypes.LAST_NAME;
                sortType = 'asc';
                break;
            case 'seed_asc':
                sortParam = sortParamTypes.SEED;
                sortType = 'asc';
                break;
            case 'seed_desc':
                sortParam = sortParamTypes.SEED;
                sortType = 'desc';
                break;

            default:
                break;
        }
        if (sortParam === sortParamTypes.SEED) {
            if (currentDraw.data.formatTypeId === eventFormatTypeIds.SINGLES) {
                seedsArray = seedingManualOrderMember.filter((item) => item.seedNumber !== null);
            } else {
                seedsArray = seedingManualOrderTeam.filter((team) => team.seedNumber !== null);
            }
        }
        dispatch(drawEditActions.orderPlayers({ sortParam, sortType, formatTypeId: currentDraw.data.formatTypeId, utrTypeId, seedsArray }));

        setPlayersFilter(option);
    };

    const handleSeedSettingClick = (option) => {
        setSeedTypeSetting(option.value);
        setSeedPercentageSetting(option.seedingPercentage || undefined);
        setDisplaySeedingOrder(newSeedingSettingsEnabled && option.value === 2);
        handleSortPlayersClick({
            value: isPickleBallEvent ? 'pkbr_desc' : 'utr_desc',
            label: `${isPickleBallEvent ? ratingTypes.pickleball : ratingTypes.tennis} (high to low)`,
        });
    };

    const handleHideSeedSettingClick = () => {
        setShowSeedVisibilityUpdateConfirmationModal(true);
    };

    const handleSeedVisibilityUpdate = async () => {
        dispatch(drawEditActions.updateHideSeedNumbers(!hideSeedNumbers));
        setHideSeedNumbers(!hideSeedNumbers);
        setShowSeedVisibilityUpdateConfirmationModal(false);
    };

    const handleMemberSeedOrderChanged = (player, seedingOrder) => {
        const totalPlayers = placed.length + notPlaced.length;
        const clampedSeedNumber = seedingOrder ? Math.max(1, Math.min(totalPlayers, seedingOrder)) : null;

        const existingSeedIndex = seedingManualOrderMember.findIndex(item => item.seedNumber === clampedSeedNumber);
        if (seedingOrder !== '' && existingSeedIndex !== -1) {
            dispatch(showErrorToast({
                message: 'Cannot assign duplicate seed order values',
            }));

            setSeedingManualOrderMember((prevOrder) => {
                return prevOrder.map(item => (item.memberId === player.memberId
                        ? { ...item, seedNumber: '' }
                        : item));
            });
            return;
        }

        setSeedingManualOrderMember((prevOrder) => {
            const existingMemberIndex = prevOrder.findIndex(item => item.memberId === player.memberId);
            if (existingMemberIndex !== -1) {
                // If member exists, update seedNumber
                return prevOrder.map((item, index) => (index === existingMemberIndex
                    ? { ...item, seedNumber: clampedSeedNumber }
                    : item));
            }
            // If member does not exist, add new member
            return [...prevOrder, { memberId: player.memberId, seedNumber: clampedSeedNumber }];
        });
    };

    const handleTeamSeedOrderChanged = (teamId, seedingOrder) => {
        const totalTeams = placed.length + notPlaced.length;
        const clampedSeedNumber = seedingOrder ? Math.max(1, Math.min(totalTeams, seedingOrder)) : null;

        const existingSeedIndex = seedingManualOrderTeam.findIndex(item => item.seedNumber === clampedSeedNumber);
        if (seedingOrder !== '' && existingSeedIndex !== -1) {
            dispatch(showErrorPopup({
                message: 'Cannot assign duplicate seed order values',
            }));

            setSeedingManualOrderTeam((prevOrder) => {
                return prevOrder.map(item => (item.teamId === teamId
                    ? { ...item, seedNumber: '' }
                    : item));
            });
            return;
        }

        setSeedingManualOrderTeam((prevOrder) => {
            const existingTeamIndex = prevOrder.findIndex(item => item.teamId === teamId);
            if (existingTeamIndex !== -1) {
                // If team exists, update seedNumber
                return prevOrder.map((item, index) => (index === existingTeamIndex
                        ? { ...item, seedNumber: clampedSeedNumber }
                        : item));
            }
            // If team does not exist, add new member
            return [...prevOrder, { teamId, seedNumber: clampedSeedNumber }];
        });
    };

    const handlePlayerTagSubmit = ({ tagId }) => {
        if (hasRetiredTag(tagId)) {
            setShowTagConfirmPopup(true);
            setTagId(parseInt(tagId));
        } else {
            confirmPlayerTag(tagId);
        }
    };

    const handlePlayerTagConfirm = () => {
        confirmPlayerTag(tagId);
    };

    const confirmPlayerTag = (tagId) => {
        dispatch(drawEditActions.setResetTimer(true));
        const { memberId, teamId } = tagPlayer;
        dispatch(drawEditActions.setDrawTag({ memberId, teamId, tagId }));
        closeModals();
    };

    const getTagName = (tagId) => {
        const tag = tagTypes?.find(tag => tag.id === tagId);
        return tag?.label;
    };

    // DRAWS

    const handleAutofillDrawClick = async () => {
        dispatch(drawEditActions.setResetTimer(true));
        const { roundId, isRoundAutoFill } = autofill;

        if (isRoundAutoFill) {
            const isError = (currentDraw.data.formatTypeId === eventFormatTypeIds.SINGLES && selected.length < 2) ||
                (currentDraw.data.formatTypeId !== eventFormatTypeIds.SINGLES && selectedTeams.length < 2);
            if (isError) {
                setAutofill({
                    ...autofill,
                    error: `Please select at least 2 ${currentDraw.data.formatTypeId === eventFormatTypeIds.SINGLES ? 'players' : 'teams'}`,
                });
                return;
            }
            if (currentDraw.unsavedChanges) {
                await dispatch(drawEditActions.saveDrawUpdates({}));
            }
            await dispatch(drawEditActions.autofillDrawRound(roundId, selected, selectedTeams));
        } else {
            if (currentDraw.unsavedChanges) {
                await dispatch(drawEditActions.saveDrawUpdates({}));
            }
            if (newSeedingSettingsEnabled) {
                const seedSettings = {
                    seedingTypeId: seedTypeSetting,
                    seedingPercentage: seedPercentageSetting,
                    hideSeedNumbers,
                    manualSeedingSortAscending: true,
                    drawMemberSeedNumbers: seedingManualOrderMember.filter(member => member.seedNumber !== null),
                    drawTeamSeedNumbers: seedingManualOrderTeam.filter(member => member.seedNumber !== null),
                };
                await dispatch(drawEditActions.autofillDraw(seedSettings));
            } else {
                await dispatch(drawEditActions.autofillDraw());
            }
        }
        closeModals();
    };

    const autoFillAutomated = () => {
        dispatch(drawEditActions.setResetTimer(true));
        if (parentDraw.data.formatTypeId === eventFormatTypeIds.SINGLES) {
            dispatch(drawEditActions.setSelected(parentDraw.data.members.map(m => m.memberId)));
        } else {
            dispatch(drawEditActions.setSelectedTeams(parentDraw.data.teams.map(t => t.teamId)));
        }
        setAutofill({ ...autofill, showModal: false, automated: true });
        setMove({
            copy: true,
            showModal: true,
            fromDrawId: parentDraw.data.id,
            allPlayersTab: false,
            forceDoubles: !!selectedTeams.length,
            showCreateForm: false,
            showCreateAutomated: true,
        });
    };

    // MODALS

    const showRemoveModal = (drawId) => {
        dispatch(drawEditActions.setResetTimer(true));
        if (selected.length || selectedTeams.length) {
            setRemove({
                type: (!drawId || drawId === 'notInDraw') ? 'event' : 'draw',
                showModal: true,
                drawId,
            });
        }
    };

    const showMoveModal = (fromDrawId, isAllPlayersTab = false) => {
        dispatch(drawEditActions.setResetTimer(true));
        if (selected.length || selectedTeams.length) {
            setMove({
                copy: !fromDrawId || fromDrawId === 'notInDraw' || isAllPlayersTab,
                showModal: true,
                fromDrawId,
                allPlayersTab: isAllPlayersTab,
            });
        }
    };

    const showSplitModal = (drawId) => {
        dispatch(drawEditActions.setResetTimer(true));
        if (selectedTeams.length) {
            setSplit({ ...split, showModal: true, drawId });
        }
    };

    const closeModals = () => {
        dispatch(drawEditActions.setResetTimer(true));
        if (move.showCreateAutomated) {
            // reset auto selection for automated draw creation
            dispatch(drawEditActions.setSelected([]));
            dispatch(drawEditActions.setSelectedTeams([]));
        }
        setMove({ ...move, showModal: false });
        setRemove({ ...remove, showModal: false });
        setSplit({ ...split, showModal: false });
        setAutofill({ ...autofill, showModal: false });
        setAutofillRatingWarning({ ...autofillRatingWarning, showModal: false });
        setTagPlayer({ showModal: false });
        // reset any default form values
        setShowTagConfirmPopup(false);
        setTagId(null);
    };

    return (
        <div>
            <DrawPlayersListV2
                isReadOnly={isReadOnly}
                utrType={utrType}
                playersFilter={playersFilter}
                placed={placed}
                notPlaced={notPlaced}
                waitlist={waitlist}
                available={available}
                notInDraw={notInDraw}
                notInDrawTeams={notInDrawTeams}
                selected={selected}
                selectedTeams={selectedTeams}
                selectedNotInDraw={selectedNotInDraw}
                selectedTeamsNotInDraw={selectedTeamsNotInDraw}
                preventSelectMove={preventSelectMove}
                selectedSection={selectedSection}
                drawListFilter={''}
                playersDict={playersDict}
                playersDictByMemberId={playersDictByMemberId}
                teamsDict={teamsDict}
                membersHaveResults={membersHaveResults}
                teamsHaveResults={teamsHaveResults}
                membersInDraw={membersInDraw}
                teamsInDraw={teamsInDraw}
                membersInTeams={membersInTeams}
                togglePlayerSelect={togglePlayerSelect}
                toggleNDPlayerSelect={toggleNDPlayerSelect}
                toggleTeamSelect={toggleTeamSelect}
                toggleNDTeamSelect={toggleNDTeamSelect}
                playerListFilter={playerListFilter}
                setPlayerListFilter={setPlayerListFilter}
                handleSelectAll={handleSelectAll}
                toggleSectionSelect={toggleSectionSelect}
                players={players}
                teams={teams}
                createTeam={createTeam}
                showSplitModal={showSplitModal}
                showMoveModal={showMoveModal}
                showRemoveModal={showRemoveModal}
                addToDraw={addToDraw}
                showAutofillModal={showAutofillModal}
                handlePlayerPopoverClick={handlePlayerPopoverClick}
                handleSortPlayersClick={handleSortPlayersClick}
                setSelectedSection={setSelectedSection}
                sportTypeId={sportTypeId}
                handleSeedSettingClick={handleSeedSettingClick}
                selectedSeedType={seedTypeSetting}
                selectedSeedPercentage={seedPercentageSetting}
                hideSeedSelection={hideSeedNumbers}
                handleHideSeedSettingClick={handleHideSeedSettingClick}
                displaySeedingOrder={displaySeedingOrder}
                handleMemberSeedOrderChanged={handleMemberSeedOrderChanged}
                handleTeamSeedOrderChanged={handleTeamSeedOrderChanged}
                seedingManualOrderMember={seedingManualOrderMember}
                seedingManualOrderTeam={seedingManualOrderTeam}
                setSeedingManualOrderMember={setSeedingManualOrderMember}
                setSeedingManualOrderTeam={setSeedingManualOrderTeam}
            />
            {typeof window !== 'undefined' && (
                <div>
                    {remove.showModal && (
                        <Modal visible={remove.showModal} onClickBackdrop={closeModals} dialogClassName="modal-lg">
                            <div className="modal-header">
                                <div className="text-medium" data-testid="modal.draw-edit.remove-players.title">{move.type === 'event' ? 'Withdraw' : 'Remove'}
                                    {selected.length ? ` ${selected.length} player(s)` : ''}
                                    {selected.length && selectedTeams.length ? ' and' : ''}
                                    {selectedTeams.length ? ` ${selectedTeams.length} team(s)` : ''}
                                    ...
                                </div>
                                <div className="close-icon" onClick={closeModals} data-testid="modal.draw-edit.remove-players.close-btn"><i className="utr utr-close" /></div>
                            </div>
                            <div className="modal-body">
                                <div className="mb24" data-testid="modal.draw-edit.remove-players.message">Remove
                                    {players.filter(player => selected.includes(player.id)).map((player, i, { length }) => <span key={player.id}> <span className="text-dark">{player.displayName}</span>{i === length - 1 ? '' : ', '}</span>)}
                                    {selected.length && selectedTeams.length ? ' and' : ''}
                                    {teams.filter(team => selectedTeams.includes(team.id)).map((team, i, { length }) => <span key={team.id}> <span className="text-dark">{team.displayName}</span>{i === length - 1 ? '' : ', '}</span>)}…
                                </div>

                                <div className={`radio radio-large mb24 d-flex selected`}>
                                    <div className="radio-wrapper">
                                        <div className={`radio-check`}><Img src="/img/icons/checkmark-icon.svg" /></div>
                                    </div>
                                    <div className="label">
                                        <div className="text text-medium text-dark" data-testid="modal.draw-edit.remove-players.from-draw-label">From this draw</div>
                                        <div className="description" data-testid="modal.draw-edit.remove-players.from-draw-desc">These players will still be available to play in the event</div>
                                    </div>
                                </div>

                                <p className="text-center text-14" data-testid="modal.draw-edit.remove-players.info-text">
                                    Players will be removed from this draw, but still available to play in the event.
                                </p>
                                <button type="button" className={`btn btn-xl btn-block btn-primary`} onClick={() => removePlayers()} data-testid="modal.draw-edit.remove-players.confirm-btn">REMOVE</button>
                            </div>
                        </Modal>
                    )}
                    {split.showModal && (
                        <Modal visible={split.showModal} onClickBackdrop={closeModals} dialogClassName="modal-lg">
                            <div className="modal-header">
                                <div className="text-medium" data-testid="modal.draw-edit.split-team.title">Split Doubles Team{selectedTeams.length > 1 ? 's' : ''}</div>
                                <div className="close-icon" onClick={closeModals} data-testid="modal.draw-edit.split-team.close-btn"><i className="utr utr-close" /></div>
                            </div>
                            <div className="modal-body">
                                <div className="mb24" data-testid="modal.draw-edit.split-team.message">Are you sure you want to split {selectedTeams.length} team{selectedTeams.length > 1 ? 's' : ''}?
                                    {/* {teams.filter(team => selectedTeams.includes(team.id)).map((team, i, { length }) => <span key={team.id}> <span className="text-dark">{team.displayName}</span>{i === length - 1 ? '' : ', '}</span>)}? */}
                                </div>
                                <p className="mb56" data-testid="modal.draw-edit.split-team.info-text">
                                    Once they are split they will be added to the &quot;Available Players&quot; section. You can change their partners and create new teams at any time.
                                </p>
                                <button type="button" className={`btn btn-xl btn-block btn-primary`} onClick={splitTeams} data-testid="modal.draw-edit.split-team.confirm-btn">SPLIT TEAM{selectedTeams.length > 1 ? 'S' : ''}</button>
                            </div>
                        </Modal>
                    )}
                    {autofillRatingWarning.showModal && (
                        <Modal visible={autofillRatingWarning.showModal} onClickBackdrop={closeModals} dialogClassName="modal-lg">
                            <div className="modal-header">
                                <div className="text-medium" />
                                <div className="close-icon" onClick={closeModals} data-testid="modal.draw-edit.autofill-rating-warning.close-btn"><i className="utr utr-close" /></div>
                            </div>
                            <div className={`modal-body`}>
                                <div className="mt12 mb24" data-testid="modal.draw-edit.autofill-rating-warning.message">
                                    The {ratingTypes.tennis} range of players added to this draw is greater than 2.00.
                                    This may result in a less competitive experience.
                                    UTR Sports recommends separating players into draws where they are within 2.00 {ratingTypes.tennis} if you are able to do so.
                                </div>
                                <div className="row mt16">
                                    <div className={`col-6`}>
                                        <button
                                            onClick={closeModals}
                                            type="button"
                                            className="btn btn-default btn-xl text-uppercase btn-block"
                                            data-testid="modal.draw-edit.autofill-rating-warning.back-btn"
                                        >
                                            Go Back
                                        </button>
                                    </div>
                                    <div className={`col-6`}>
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-xl text-uppercase btn-block"
                                            onClick={() => showAutofillModal(autofillRatingWarning.drawId, autofillRatingWarning.roundId, false)}
                                            data-testid="modal.draw-edit.autofill-rating-warning.continue-btn"
                                        >
                                            Continue to Auto-Fill
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    )}
                    {autofill.showModal && (
                        <>
                            {autofill.isRoundAutoFill && (
                                <Modal visible={true} onClickBackdrop={closeModals} dialogClassName="modal-lg">
                                    <div className="modal-header">
                                        <div className="text-medium" data-testid="modal.draw-edit.autofill-round.title">Auto-Fill Draw Round</div>
                                        <div className="close-icon" onClick={closeModals} data-testid="modal.draw-edit.autofill-round.close-btn"><i className="utr utr-close" /></div>
                                    </div>
                                    <div className={`modal-body ${styles.roundModalSelectList}`}>
                                        {unsavedChanges && <div className="mb24 text-error" data-testid="modal.draw-edit.autofill-round.warning">Warning! Unsaved changes will be lost. If you want to keep your unsaved changes, save your updates before continuing.</div>}
                                        <DrawRoundPlayersListV2
                                            draw={currentDraw.data}
                                            parentDraw={parentDraw.data}
                                            available={placed.concat(notPlaced)}
                                            selected={selected}
                                            selectedTeams={selectedTeams}
                                            utrType={utrType}
                                            playersDictByMemberId={playersDictByMemberId}
                                            teamsDict={teamsDict}
                                        />
                                        <div className="mt12 mb12 text-small text-danger text-center" data-testid="modal.draw-edit.autofill-round.error">{autofill.error}</div>
                                        <button
                                            type="button"
                                            className={`btn btn-xl btn-block btn-primary`}
                                            onClick={handleAutofillDrawClick}
                                            disabled={isSaving || !(selected.length || selectedTeams.length)}
                                            data-testid="modal.draw-edit.autofill-round.confirm-btn"
                                        >
                                            Confirm Auto-Fill Draw Round
                                        </button>
                                    </div>
                                </Modal>
                            )}
                            {!autofill.isRoundAutoFill && (
                                <Modal visible={true} onClickBackdrop={closeModals} dialogClassName="modal-lg">
                                    <div className="modal-header">
                                        <div className="text-medium" data-testid="modal.draw-edit.autofill.title">Auto-Fill Draw</div>
                                        <div className="close-icon" onClick={closeModals} data-testid="modal.draw-edit.autofill.close-btn"><i className="utr utr-close" /></div>
                                    </div>
                                    <div className="modal-body">
                                        {unsavedChanges && <div className="mb24 text-error" data-testid="modal.draw-edit.autofill.warning">Warning! Unsaved changes will be lost. If you want to keep your unsaved changes, save your updates before continuing.</div>}
                                        {newSeedingSettingsEnabled ? (
                                            <ul className="mb56">
                                                <li>Players are placed in the draw according to your selected seeding method on the draw player bank.</li>
                                                <li>If you did not select a seeding method, players will be default seeded by rating. </li>
                                                <li>Seeds and byes are assigned to their designated spots first. The remaining spots are filled by the rest of the players and byes.</li>
                                                <li>If players are already placed in the draw:
                                                    <div>- This will clear existing placements and automatically fill the first round of the draw.</div>
                                                    <div>- Players listed as placed or not placed will be added to the draw, while those on the withdraw list will be excluded.</div>
                                                </li>
                                                <li>If you select to hide seeds from the public view, seeds will remain visible in the event desk but not on the event page or in printed draw views. This setting can be changed at any time during the event.</li>
                                            </ul>
                                        ) : (
                                            <ul className="mb56">
                                                <li>Players in the placed and not-placed lists will be placed in the draw. Players in the withdraw list will not be placed in the draw.</li>
                                                <li>Seeding is based on player ratings.</li>
                                                <li>Seeds and corresponding byes (if any) are placed first in their appropriate spots. Remaining players and byes fill out the rest of the draw. </li>
                                                <li>If you already have players placed in the draw, this action will clear them and auto-fill the first round of the draw. </li>
                                            </ul>
                                        )}
                                        <div className="row mt16">
                                            <div className="col">
                                                <button
                                                    type="button"
                                                    className={`btn btn-xl btn-block btn-primary text-uppercase`}
                                                    onClick={handleAutofillDrawClick}
                                                    disabled={isSaving}
                                                    data-testid="modal.draw-edit.autofill.confirm-btn"
                                                >
                                                    Confirm Auto-Fill Draw
                                                </button>
                                            </div>
                                            {!isGroupDraw && !newSeedingSettingsEnabled && (
                                                <div className="col">
                                                    <button
                                                        type="button"
                                                        className={`btn btn-xl btn-block btn-default text-uppercase`}
                                                        onClick={autoFillAutomated}
                                                        disabled={isSaving}
                                                        data-testid="modal.draw-edit.autofill.create-automated-btn"
                                                    >
                                                        Create New Automated Draw
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Modal>
                            )}
                        </>
                    )}
                    {tagPlayer.showModal && (
                        <SingleSelectPopup
                            fieldName="tagId"
                            submitLabel="Update"
                            options={tagTypes}
                            emptyOption={'Not tagged'}
                            onCloseClick={closeModals}
                            onSubmit={handlePlayerTagSubmit}
                            data-testid="modal.draw-edit.tag-player"
                        />
                    )}
                    {showTagConfirmPopup && (
                        <ConfirmActionPopup
                            onCtaClick={handlePlayerTagConfirm}
                            onCloseClick={closeModals}
                            confirmationMessage={`Are you sure you want to tag this player as ${getTagName(tagId)}? Please note that doing so will remove this player from the Standings calculations.`}
                            confirmButtonLabel={'Confirm'}
                            data-testid="modal.draw-edit.tag-player-confirm"
                        />
                    )}
                    {showSeedVisibilityUpdateConfirmationModal && (
                        <Modal visible={true} onClickBackdrop={() => setShowSeedVisibilityUpdateConfirmationModal(false)} dialogClassName="modal-md mt132">
                            <div className="modal-header">
                                <div className="text-medium" data-testid="modal.draw-edit.seed-visibility.title">Hide seeds from players</div>
                                <div className="close-icon" onClick={() => setShowSeedVisibilityUpdateConfirmationModal(false)} data-testid="modal.draw-edit.seed-visibility.close-btn"><i className="utr utr-close" /></div>
                            </div>
                            <div className={`modal-body ${styles.roundModalSelectList}`}>
                                <div className="mt16 mb24 text-small text-dark text-center" data-testid="modal.draw-edit.seed-visibility.message">Are you sure you want to update seed visibility?</div>
                                <div className="d-flex aic jcc">
                                    <button
                                        type="button"
                                        className={`btn btn-default btn-xl`}
                                        onClick={() => setShowSeedVisibilityUpdateConfirmationModal(false)}
                                        data-testid="modal.draw-edit.seed-visibility.cancel-btn"
                                    >
                                        No
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn btn-xl btn-primary ml12`}
                                        onClick={() => handleSeedVisibilityUpdate()}
                                        data-testid="modal.draw-edit.seed-visibility.confirm-btn"
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </Modal>
                    )}
                </div>
            )}
        </div>
    );
};

DrawsPlayerListWrapperV2.propTypes = {
    membersInDraw: PropTypes.arrayOf(PropTypes.any),
    teamsInDraw: PropTypes.arrayOf(PropTypes.any),
    membersInWaitlist: PropTypes.arrayOf(PropTypes.any),
    teamsInWaitlist: PropTypes.arrayOf(PropTypes.any),
};
DrawsPlayerListWrapperV2.defaultProps = {
    membersInDraw: [],
    teamsInDraw: [],
    membersInWaitlist: null,
    teamsInWaitlist: null,
};

export default DrawsPlayerListWrapperV2;
